export function scrollToElement(element: HTMLElement) {
    if(element === null) {
        return;
    }

    element.scrollIntoView();
}
